@if (loading) {
  <div class="loading-container">
    <p-progressSpinner styleClass="custom-spinner" strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
  </div>
} @else {
  <div class="my-documents-container">
    <div class="sidebar" *ngIf="selectedCategory === null">
      <div class="sidebar-header">
        <h3>Categorie ({{ categories.length }})</h3>
      </div>
      <div class="categories-list">
        <div
          *ngFor="let category of categories"
          class="category-item"
          [class.selected]="selectedCategory === category"
          (click)="selectCategory(category)"
        >
          <div class="category-content">
            <span class="category-name">{{ category.title }}</span>
            <span class="category-count">{{ category.docCount }}</span>
          </div>
          <div
            class="category-status"
            [class.available]="category.docCount > 0"
            [class.warning]="category.docCount > 0 && hasCategoryWarnings(category)"
          >
            {{
              category.docCount > 0
                ? hasCategoryWarnings(category)
                  ? 'Avviso importante'
                  : 'Documenti Disponibili'
                : 'Nessun Documento'
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="main-content" *ngIf="selectedCategory !== null">
      <div class="sidebar-header">
        <button
          pButton
          type="button"
          icon="pi pi-arrow-left"
          class="p-button-text back-button"
          (click)="deselectCategory()"
        ></button>
        <h3>Documenti</h3>
      </div>
      <div class="content-header">
        <h2>{{ selectedCategory.title || 'Documenti' }}</h2>
        <div>
          <h3 class="docs-count">{{ visibleDocuments.length }}</h3>
          <p>Documento</p>
        </div>
      </div>

      <div class="warning-container" *ngIf="hasCategoryWarnings(selectedCategory)">
        <div class="warning-message" *ngFor="let warning of selectedCategory?.warnings ?? []">
          <p-message
            severity="warn"
            icon="pi pi-exclamation-triangle"
            [text]="warning.description"
            styleClass="w-full"
          />
        </div>
      </div>

      <p-tabs [value]="activeTab">
        <p-tablist>
          <p-tab [value]="0" (click)="setActiveTab(0)">
            <p-button icon="pi pi-paperclip" [rounded]="true" [outlined]="activeTab !== 0" />
          </p-tab>
          <p-tab [value]="1" (click)="setActiveTab(1)" *ngIf="hasCategoryNotes(selectedCategory)">
            <p-button icon="pi pi-info-circle" [rounded]="true" [outlined]="activeTab !== 1" />
          </p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel [value]="0">
            <div class="documents-section">
              <div class="pre-table-section">
                <h3>Trovati {{ visibleDocuments.length }} Documenti</h3>

                <div class="search-bar">
                  <!-- <span class="p-input-icon-right">
                <i class="pi pi-search"></i>
                <input type="text" pInputText placeholder="Cerca" />
              </span> -->
                  <p-iconfield class="flex-1">
                    <p-inputicon class="pi pi-search" />
                    <input
                      type="text"
                      pInputText
                      placeholder="Cerca"
                      [(ngModel)]="searchDocuments"
                      (ngModelChange)="searchDocument()"
                    />
                  </p-iconfield>
                </div>
              </div>

              <p-table [value]="visibleDocuments" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Nome</th>
                    <th>Accedi al Documento</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-document>
                  <tr>
                    <td class="name-col">
                      <div class="document-name">
                        <i class="pi pi-star-fill mr-2" *ngIf="!document.openedAt"></i>
                        {{ document.title }}
                      </div>
                      <div class="document-subname">
                        Data archiviazione: {{ document.archiveDate | date: 'dd/MM/yyyy' }}
                      </div>
                      <div class="document-subtitle" *ngIf="document.openedAt || document.notesOpenedAt">
                        <ng-container *ngIf="document.openedAt">
                          Documento letto il:
                          {{
                            document.openedAt
                              ? (document.openedAt | date: 'dd/MM/yyyy')
                              : 'Data di Lettura non presente'
                          }}
                        </ng-container>
                        <br />
                        <ng-container *ngIf="document.notesOpenedAt">
                          Note lette il:
                          {{
                            document.notesOpenedAt
                              ? (document.notesOpenedAt | date: 'dd/MM/yyyy')
                              : 'Data di Lettura Note non presente'
                          }}
                        </ng-container>
                      </div>
                    </td>
                    <td class="pdf-col">
                      <p-button
                        variant="outlined"
                        type="button"
                        icon="pi pi-file-pdf"
                        class="p-button-rounded p-button-text mb-2"
                        (onClick)="downloadDocumentPdf(document)"
                      ></p-button>
                    </td>
                    <td *ngIf="documentsHasNote()" class="notes-col">
                      <p-button
                        variant="outlined"
                        type="button"
                        icon="pi pi-clipboard"
                        class="p-button-rounded p-button-text"
                        *ngIf="document.note"
                        (onClick)="openDocumentNotes(document)"
                      ></p-button>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="5" class="empty-message">Nessun Documento trovato</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-tabpanel>

          <p-tabpanel [value]="1" *ngIf="hasCategoryNotes(selectedCategory)">
            <p-stepper [value]="activeNoteStep" class="notes-stepper">
              <p-step-list>
                <p-step
                  *ngFor="let note of selectedCategory?.notes ?? []; let index = index"
                  [value]="index + 1"
                  (click)="setActiveNoteStep(index + 1)"
                >
                </p-step>
              </p-step-list>

              <p-step-panels>
                <p-step-panel *ngFor="let note of selectedCategory?.notes ?? []; let index = index" [value]="index + 1">
                  <ng-template #content>
                    <div class="mb-4" [innerHTML]="note.content"></div>
                  </ng-template>
                </p-step-panel>
              </p-step-panels>
            </p-stepper>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  </div>

  <p-dialog
    [(visible)]="notesDialogVisible"
    header="Note di Accompagnamento"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="true"
    [baseZIndex]="10000"
    (onHide)="onCloseDialog()"
    [draggable]="false"
    [resizable]="true"
  >
    <!-- Dialog Content -->
    <div class="flex align-items-center mb-4">
      <span class="text-900">{{ activeDocumentNotes }}</span>
    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <p-button
          label="{{ 'global.close.label' | translate }}"
          icon="pi pi-times"
          severity="secondary"
          (onClick)="onCloseDialog()"
        >
        </p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- <app-repository-show-file-dialog
  [visible]="showDetailFileDialog"
  [fileType]="detailFileType"
  (close)="onCloseShowDialog()"
  [fileUrl]="fileUrl"
  [fileName]="fileName"
/> -->
  <p-dialog
    [(visible)]="showDetailFileDialog"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    (onHide)="onCloseShowDialog()"
    [contentStyle]="{ padding: '0', overflow: 'hidden' }"
    [style]="{ width: '100vw', height: '100vh' }"
  >
    <ng-template #header>
      {{ fileName }}
      <p-button
        [label]="'my-documents-mobile.download.label' | translate"
        icon="pi pi-download"
        size="small"
        class="p-button-text p-button-plain"
        (onClick)="getFileUrl()"
      >
      </p-button>
    </ng-template>

    <ng2-pdfjs-viewer
      [pdfSrc]="fileUrl"
      [showSpinner]="true"
      [theme]="'light'"
      [showOpenFile]="false"
      [showDownload]="false"
      [showPrint]="false"
      [showFullScreen]="false"
      [showViewBookmark]="false"
      [showToolbarLeft]="false"
      [showToolbarMiddle]="false"
      [showToolbarRight]="false"
      [showSecondaryToolbarToggle]="false"
      [showSidebar]="false"
      [showSidebarLeft]="false"
      [showSidebarRight]="false"
      customCSS=".toolbar {display: none} #viewerContainer {inset: 0 !important;}"
    ></ng2-pdfjs-viewer>
  </p-dialog>
}
